import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";

const useTickets = ({
  searchParam,
  pageNumber,
  status,
  date,
  showAll,
  queueIds,
  withUnreadMessages,
  isGroup,
  tagIds,
  userIds,
  whatsappIds,
  dataInicio,
  dataFim,
  visao,
  onlyFavorites,
  ultimosDias,
  agruparPorContato,
  sync,
}) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTickets = async () => {
        try {
          const { data } = await api.get("/tickets", {
            params: {
              searchParam,
              pageNumber,
              status,
              date,
              // Período escolhido nos filtros da lista.
              dataInicio: dataInicio || undefined,
              dataFim: dataFim || undefined,
              // Recorte por período. Vai só quando a aba pede — hoje a de
              // encerrados, que sem isso cresce para sempre.
              ultimosDias,
              showAll,
              queueIds,
              withUnreadMessages,
              isGroup,
              // Eixo dono/setor da aba ("minhas" | "setor"); sem ele a
              // lista continua recortada só pela situação.
              visao,
              onlyFavorites: onlyFavorites ? "true" : undefined,
              // Uma linha por contato: na aba de encerrados o mesmo cliente
              // aparecia uma vez por chamado antigo.
              agruparPorContato: agruparPorContato ? "true" : undefined,
              // O backend espera JSON de ids; array cru viraria
              // "1,2" e ele nao saberia separar.
              tagIds: tagIds?.length ? JSON.stringify(tagIds) : undefined,
              userIds: userIds?.length ? JSON.stringify(userIds) : undefined,
              whatsappIds: whatsappIds?.length
                ? JSON.stringify(whatsappIds)
                : undefined,
            },
          });
          setTickets(data.tickets);

          // O encerramento automático por inatividade saiu daqui: rodava
          // no navegador, então só acontecia enquanto alguém tivesse a tela
          // aberta, e o mesmo prazo valia para todas as conexões. Agora é
          // regra da conexão, aplicada pelo worker (ApplyTicketRulesService).

          setHasMore(data.hasMore);
          setCount(data.count);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };

      fetchTickets();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    pageNumber,
    status,
    date,
    showAll,
    queueIds,
    withUnreadMessages,
    isGroup,
    tagIds,
    userIds,
    whatsappIds,
    dataInicio,
    dataFim,
    visao,
    onlyFavorites,
    ultimosDias,
    agruparPorContato,
    sync,
  ]);

  return { tickets, loading, hasMore, count };
};

export default useTickets;
